import EmisoresList from './EmisoresList'

export default {
  list: EmisoresList,
}
